import HeaderSubSection from "../../components/HeaderSubSection/index.vue";
import wishlistListSection from "../../components/wishlistListSection/index.vue";
import wishlistArticleSection from "../../components/wishlistArticleSection/index.vue";

export default {
  name: "wishlistPage",
  components: {
    HeaderSubSection,
    wishlistListSection,
    wishlistArticleSection,
  },
};
